import application from 'application/application';

import template from './upload-image-preview.template.html';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.upload-image-preview', {
				views: {
					'root': {
						templateUrl: template
					}
				},
				data: {
					documentTitle: 'Login'
				},
				params: {
					authentication: false
				}
			});

	}]);
